import React from 'react'
import { IconButton, useTheme } from '@mui/material'
import type { IconButtonProps } from '@mui/material'
import { MoreVertical } from '../../Icon'

const SideMenuButton: React.FC<IconButtonProps> = (props) => {
  const theme = useTheme()

  return (
    <IconButton size="medium" variant="outlined" color="primary" {...props}>
      <MoreVertical color={theme.palette.primary.main} />
    </IconButton>
  )
}

export default SideMenuButton
